export interface ProductDetailsCart {
  subtotalPrice: number;
  subtotalDiscountedPrice: number;
  subtotalDiscountedPoints?: number;
  subtotalPoints?: number;
  products: ProductCart[];
  /**
   * FCR 19.1 — backend gate (from `GET cart`): whether the cart may proceed to checkout under the
   * monthly order limit. When false, checkout is blocked and the adjustment flow (auto-reduce/remove)
   * runs instead. Optional so older responses stay valid.
   */
  isValidForCheckout?: boolean;
}

export interface ProductDetailsCartDto extends Omit<ProductDetailsCart, 'products'> {
  products: ProductCartDto[];
}

export const mapProductDetailsCartToInternal = (model: ProductDetailsCartDto): ProductDetailsCart => ({
  ...model,
  products: model.products.map((p) => ({ ...p, images: p.images.map((imageObj) => imageObj.sourceSet) })),
});

export interface ProductCart {
  quantity: number;
  isAvailable: boolean;
  /**
   * RCP-458 — the cart holds more units of this SKU (summed over all its lines) than can be ordered.
   * Optional so older responses stay valid.
   */
  exceedsAvailableStock?: boolean;
  /**
   * RCP-458 — the most units of this SKU that can be ordered, a total over all its lines. Bounds the
   * stepper and "Add to cart" only; never shown to the player (DoD13).
   */
  availableCount?: number;
  productId: number;
  name: string;
  brandId: number;
  brandName: string;
  points: number;
  price: number;
  isPromo: boolean;
  discountedPrice: number;
  pointConversionRate?: number;
  estimatedShippingDays: string;
  images: Array<Array<string>>;
  attachedItem?: ProductCart[];
  visibleInCart?: boolean;
  lineNumber?: number;
  relatedLineNumber?: number;
  relatedParentProducts?: RelatedParentProduct[];
}

export interface ProductCartDto extends Omit<ProductCart, 'images'> {
  images: Array<{ sourceSet: string[] }>;
}

export interface ProductCartWithEngraving extends ProductCart {
  varianceSelections?: {
    options?: {
      selectedValue?: string;
    }[];
  };
  varianceSelectionsJson?: string;
}
export interface RelatedParentProduct {
  productId: number;
  name: string;
  partNumber: string;
  brandId: number;
  brandName: string;
  price: number;
  discountedPrice: number | null;
  isPromo: boolean;
  isTruckShip: boolean;
  images: string[];
  hasVariants: boolean;
}
